<template>    
  <div class="wrap">
    <header style="    display: flex;justify-content: center;">
      <span class="iconfont icon-back-left" style="position: absolute;left: 10px" @click="goBack"></span>
      <h2>{{lang.tkjl}}</h2>
    </header>
    <div class="main">
      <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom"  ref="loadmore" :auto-fill="false"
      :topPullText="lang.topPullText" :topDropText="lang.dropText" :topLoadingText="lang.loadingText" 
      :bottomPullText="lang.bottomPullText" :bottomDropText="lang.dropText" :bottomLoadingText="lang.loadingText">
        <ul>
          <li class="record-list" v-for="item in recordList" :key="item.id">
            <p><span>{{lang.txje}}：<b class="title red">{{item.amount}}</b></span></p>
            <p><span>{{lang.orderNo}}：<b>{{item.ordNo}}</b></span></p>
            <p>
              {{lang.state}}：
              <b v-if="item.status == 0 ||item.status == 5">{{lang.processing}}</b>
              <b v-else-if="item.status == 1" class="green">{{lang.succ}}</b>
              <b v-else-if="item.status == 4" class="yellow">{{lang.refuse}}</b>
              <b v-else class="red">{{lang.fail}}</b>

            </p>
            <p><span>{{lang.time}}：{{item.ctime}}</span></p>
          </li>
        </ul>
      </mt-loadmore>
      <div class="no-data" v-if="recordList.length==0">
        <img src="@img/no-data.png" />
        <p>{{lang.nomore}}</p>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {
    mapState
  } from 'vuex'
  import router from "../../router";
  export default{
    data(){
      return{
        page: 1,
        totalPg: 1,
        recordList: [],
        status:{}
      }
    },
    created(){
      this.getRecord();
    },
    computed: {
      ...mapState(['userInfo','lang'])
    },
    methods:{
      goBack(){
        this.$router.go(-1)
      },
      choseType(){
        this.getRecord();
      },
      getRecord(){
        this.$indicator.open(this.lang.loading);
        this.$doRequest('get', '/member/withdraw',{
          page:this.page
        })
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              let data = res.data;
              this.recordList = data.data;
              this.totalPg = data.totalNum;
            } else if (res.data.err == 102||res.data.err == 106) {
              this.$router.push('Login')
              sessionStorage.setItem('tk', res.data.tk);
              router.push("login")
            } else if (res.data.err == 200||res.data.err == 201){
              this.$router.push({
                name:'Maintenance',
                query:{
                  num:res.data.err
                }
              })
            }else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$messagebox({
              title: this.lang.tip,
              message: this.lang.conneterr,
              confirmButtonText: this.lang.confirm
            });
          })
      },
      loadTop() {
        //下拉刷新
        this.page = 1;
        this.getRecord();
        this.$refs.loadmore.onTopLoaded();
      },
      loadBottom() {
        this.page++;
        if(this.page<=this.totalPg){
          this.getRecord();
        }
        this.$refs.loadmore.onBottomLoaded();
      },
    }
  }
</script>
<style type="text/css"  scoped>
  .record-list {
    margin: 12px;
    padding: 12px;
    border-radius: 10px;
    background: rgba(139, 152, 244, .1);
  }
  .record-list p {
    display: flex;
    justify-content: space-between;
    line-height: 24px;
    color: #666;
  }
  .record-list p b {
    color: #333;
  }

  .record-list p .title {
    color: #000;
    font-size: 15px;
    font-weight: bold;
  }

  .record-list p .red {
    color: rgb(231, 76, 60);
  }

  .record-list p .green {
    color: green;
  }

  .record-list p .yellow {
    color: #ffb115;
  }

  .no-data{
    height: 400px;
  }
</style>